export function adicionarAnaliseIndicador(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/analiseindicadors/`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarAnaliseIndicador(idenIndicador) {
  return new Promise((resolve, _reject) => {
    window.$http.get(`/analiseindicadors/listarporprograma/${idenIndicador}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function deleteAnaliseIndicador(idenAnaliseIndicador) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseindicadors/${idenAnaliseIndicador}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function updatedAnaliseIndicador({ idenAnaliseIndicador, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseindicadors/${idenAnaliseIndicador}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarAnalisePrograma(idenPrograma) {
  return new Promise((resolve, _reject) => {
    window.$http.get(`/analiseprogramas/analiseGeral/listarPorPrograma/${idenPrograma}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarAnaliseGeral(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/analiseprogramas/incluirAnaliseGeral`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarAnaliseGeralProgr(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/analiseprogramas/incluirAnaliseGeralPrograma`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function updatedAnaliseGeralProgr({ idenAnalisePrograma, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseprogramas/${idenAnalisePrograma}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function deleteAnaliseProgrGeral(idenAnalisePrograma) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseprogramas/${idenAnalisePrograma}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function deleteAnaliseProgrGeralDevolutiva(idenAnalisePrograma) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseprogramas/${idenAnalisePrograma}`).then((res) => {
      resolve(res.data);
    });
  });
}


export function updatedAnaliseGeral({ idenAnalisePrograma, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseprogramas/${idenAnalisePrograma}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}
export function deleteAnaliseGeral(idenAnalisePrograma) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseprogramas/${idenAnalisePrograma}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function buscarAnaliseProgramaDevolutivo(idenAnalisePrograma) {
  return new Promise((resolve, _reject) => {
    window.$http.get(`/analiseprogramas/analiseDevolutivo/listarPorPrograma/${idenAnalisePrograma}`).then((res) => {
      resolve(res.data);
    });
  });
}

export function adicionarAnaliseDevolutiva(postBody) {
  return new Promise((resolve, _reject) => {
    window.$http.post(`/analiseprogramas/incluirDevolutivoAnaliseGeralPrograma`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}

export function updatedAnaliseDevolutivo({ idenAnalisePrograma, postBody }) {
  return new Promise((resolve, _reject) => {
    window.$http.put(`/analiseprogramas/${idenAnalisePrograma}`, JSON.stringify(postBody)).then((res) => {
      resolve(res.data);
    });
  });
}
export function deleteAnaliseDevolutiva(idenAnalisePrograma) {
  return new Promise((resolve, _reject) => {
    window.$http.delete(`/analiseprogramas/${idenAnalisePrograma}`).then((res) => {
      resolve(res.data);
    });
  });
}
